import { EvidenceServiceApiKey } from "@app/injectionKeys";
import { injectStrict } from "@app/utils/injectStrict";
import { computed, ref } from "vue";

const apiKey = ref();
const llmProvider = ref<"openai" | "lmstudio">("openai");

export default () => {
  const evidenceService = injectStrict(EvidenceServiceApiKey);

  async function init() {
    const { data } = await evidenceService.api.settingsControllerGetOpenAiKey();
    apiKey.value = data;
  }

  async function initLlmProvider() {
    const { data } = await evidenceService.api.settingsControllerGetLlmProvider();
    llmProvider.value = String(data.provider) as "openai" | "lmstudio";
  }

  async function configure(apiKey: string) {
    await evidenceService.api.settingsControllerSetOpenAiKey({ key: apiKey });
    await init();
  }

  const isConfigured = computed(() => !!apiKey.value);

  async function validateOpenAiKey(apiKey: string) {
    await evidenceService.api.settingsControllerValidateOpenAiKey({ key: apiKey });
  }

  return {
    apiKey,
    llmProvider,
    configure,
    init,
    initLlmProvider,
    isConfigured,
    validateOpenAiKey,
  };
};
